import * as React from "react";
import JetpackLoader from "../JetpackLoader/JetpackLoader";

interface Props {
  loading: boolean;
  children?: any;
}

export const FullScreenLoader = (props: Props) => {
  const { loading, children } = props;
  return (
    <React.Fragment key="fsloader">
      {loading && <JetpackLoader loading={true} isFullScreen={true} />}
      {!loading && children}
    </React.Fragment>
  );
};
